module.exports = __webpack_public_path__ + "img/flex.021cf950.png";